<template>
  <div class="page-reset-password" v-if="token">
    <div class="page-reset-password__header">
      <router-link class="page-reset-password__back" to="/login">
        <BaseIcon class="page-reset-password__back-icon" name="arrow-left" />
        <span class="page-reset-password__back-text">{{ $t('page.admin-user-profile.back') }}</span>
      </router-link>
      <Beacon class="page-reset-password__beacon" />
    </div>

    <div class="page-reset-password__content">
      <LargeNotice
        v-if="success"
        @click="redirect"
        icon="🙌"
        :title="$t('reset-password.success')"
        :subtitle="$t('reset-password.success-subtitle')"
        :buttonText="authenticated ? $t('title.tenders') : $t('login.log-in')"
        buttonIcon="arrow-right"
        success
      />
      <div class="page-reset-password__main" v-else>
        <SmallLogo class="explore__smiley" />

        <div class="reset-password-form__title">
          {{ $t('reset-password.title') }}
        </div>
        <div class="reset-password-form__subtitle">
          {{ $t('reset-password.subtitle') }}
        </div>

        <div class="page-reset-password__form">
          <ResetPasswordForm :token="token" @submited="onSubmit()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';
import Beacon from '@/components/Beacon.vue';
import LargeNotice from '@/components/notice/LargeNotice';
import ResetPasswordForm from '@/components/page-reset-password/ResetPasswordForm.vue';
import SmallLogo from '@/assets/images/aloha-logomark.svg';
import { paths } from '@/util/paths';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PageResetPassword',
  components: {
    BaseIcon,
    Beacon,
    LargeNotice,
    ResetPasswordForm,
    SmallLogo,
  },
  data() {
    return {
      emo: 'happy',
      success: false,
    };
  },
  inject: ['$validator'],
  computed: {
    ...mapGetters('auth', ['currentUser', 'authenticated']),
    token() {
      return this.$route.query.t;
    },
  },
  methods: {
    ...mapActions('auth', ['checkTokenValidity']),
    smileyUpdated(val) {
      this.emo = val;
    },
    redirect() {
      if (this.authenticated) {
        this.$router.push(paths.tenders);
      } else {
        this.$router.push(paths.login);
      }
    },
    onSubmit() {
      this.success = true;
    },
    async onCheckToken() {
      try {
        await this.checkTokenValidity(this.$route.query.t);
      } catch (e) {
        if (e.response.status === 404) {
          await this.$router.replace(paths.resetPasswordError);
          return;
        }

        // can't check token... So can't change password ?
        await this.$router.replace(paths.login);
      }
    },
  },
  beforeCreate() {
    if (!this.$route.query.t) {
      this.$router.replace(paths.login);
      return;
    }
  },
  mounted() {
    this.onCheckToken();
  },
};
</script>

<style lang="scss">
.page-reset-password {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  height: var(--viewport-height);
  padding: 32px;
  width: 100%;
  overflow: auto;

  &__header {
    display: flex;
    max-width: initial;
    width: 100%;
  }

  &__back {
    align-items: center;
    color: $color-normal;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-decoration: none;

    &:hover,
    &:focus,
    &:active {
      color: $color-accent;
    }

    &-icon {
      color: $color-neutral;
      height: 1.4rem;
      margin-right: 8px;
      width: 20px;
    }

    &-text {
      font-size: $font-size-small;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  &__beacon {
    margin-left: auto;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 450px;
    margin: auto;
  }

  &__main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  &__form {
    margin: 0;
    width: 100%;
  }
}

@media screen and (max-width: 784px) {
  .page-reset-password {
    &__header {
      max-width: 450px;
    }
    &__content {
      max-width: 650px;
    }
    &__form {
      margin-bottom: 92px;
    }
  }
}
</style>
